import PropTypes from 'prop-types';
import { useState } from 'react';

import { buttons } from './tabs.module.scss';
import TabButton from './search/tabbutton';
import useExpandableSearch from './search/useexpandablesearch';

const Tabs = ({
  className,
  descriptor,
  renderSearch,
  sections,
  searchDisabled,
}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const { searcher, searching, searchText } = useExpandableSearch();
  const activeSection = sections[activeIndex];
  const id = (type, index) =>
    `${descriptor}-${type}-${sections[index].title}`.replace(/\s+/gi, '');

  if (searching && !searchDisabled) {
    return (
      <div className={className}>
        {searcher}
        {renderSearch(searchText)}
      </div>
    );
  }

  return (
    <div className={className}>
      <div className={buttons} aria-label={`${descriptor} tabs`} role="tablist">
        {sections.map(({ title }, index) => (
          <TabButton
            aria-controls={id('panel', index)}
            aria-selected={index === activeIndex}
            active={index === activeIndex}
            id={id('tab', index)}
            key={title}
            onClick={() => setActiveIndex(index)}
            role="tab"
          >
            {title}
          </TabButton>
        ))}
        {!searchDisabled ? searcher : null}
      </div>
      <div
        aria-labelledby={id('tab', activeIndex)}
        id={id('panel', activeIndex)}
        role="tabpanel"
      >
        {activeSection.contents}
      </div>
    </div>
  );
};

Tabs.propTypes = {
  className: PropTypes.string,
  descriptor: PropTypes.string.isRequired,
  sections: PropTypes.oneOfType([PropTypes.array, PropTypes.node]).isRequired,
  renderSearch: PropTypes.func,
  searchDisabled: PropTypes.bool.isRequired,
};

Tabs.defaultProps = {
  searchDisabled: false,
};

export default Tabs;
